import { file } from 'jszip';
import axios from '../api/axios';

/**
 * 向Coze空间上传文件
 * @param {File} file - 要上传的本地文件对象
 * @param {Object} token - 上传选项
 * @returns {Promise<Object>} - 返回包含file_id和file_url的Promise
 */
export async function uploadFileToCoze(file, token) {
  if (!file) {
    throw new Error('请提供要上传的文件');
  }

  try {
    // 创建FormData对象，用于构造multipart/form-data格式的请求体
    const formData = new FormData();
    formData.append('file', file);
    
    // // 如果提供了文件名，则添加到FormData中
    // if (options.fileName) {
    //   formData.append('name', options.fileName);
    // }
    
    // // 如果提供了文件类型，则添加到FormData中
    // if (options.fileType) {
    //   formData.append('type', options.fileType);
    // }

    // 发送文件上传请求到Coze API
    const response = await axios.post('https://api.coze.cn/v1/files/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      }
    })

    // 检查响应数据
    if (response.data && response.data.data) {
      const fileData = response.data.data;
      return {
        file_id: fileData.id,
        //返回本地路径，不要fileData.url
        file_url: ''
      };
    } else {
      throw new Error('上传失败，返回数据格式不正确');
    }
  } catch (error) {
    console.error('文件上传失败:', error);
    if (error.response) {
      // 服务器返回错误
      throw new Error(`上传失败: ${error.response.data.message || error.response.statusText}`);
    } else if (error.request) {
      // 请求已发送但没有收到响应
      throw new Error('上传失败，服务器无响应');
    } else {
      // 请求配置出错
      throw new Error(`上传失败: ${error.message}`);
    }
  }
}

/**
 * 批量向Coze空间上传文件
 * @param {File[]} files - 要上传的本地文件对象数组
 * @param {Object} options - 上传选项，与uploadFileToCoze相同
 * @returns {Promise<Object[]>} - 返回包含多个file_id和file_url的Promise数组
 */
export async function batchUploadFilesToCoze(files, token) {
  console.log(files, files.length);
  if (!Array.isArray(files) || files.length === 0) {
    throw new Error('请提供要上传的文件数组');
  }

  try {
    // 并行上传所有文件
    const uploadPromises = files.map(file => uploadFileToCoze(file, token));
    return await Promise.all(uploadPromises);
  } catch (error) {
    console.error('批量文件上传失败:', error);
    throw error;
  }
}